









































import { Component, Prop, Ref, Vue, Watch } from "vue-property-decorator";
import ClientPartnerCreateDialogComponent from "@/components/admin/clients/partners/ClientPartnerCreateDialog.vue";
import ClientPartnerPasswordDialogComponent from "@/components/admin/clients/partners/ClientPartnerPasswordDialog.vue";
import { ClientPartnerSummary } from "@/data/models/ClientPartner";
import { listClientPartners } from "@/data/repository/ClientAdministrationRepository";
import { getReactiveActiveUser } from "@/data/repository/UserRepository";
import { adminPortalChangeAccess } from "@/permissions/UserPermissions";
import router from "@/router/router";
import { partnerSystemLabelKey } from "@/utils/ClientPartners";
import { ComponentName } from "@/utils/RouteGuards";

@Component({
  components: {
    "client-partner-create-dialog": ClientPartnerCreateDialogComponent,
    "client-partner-password-dialog": ClientPartnerPasswordDialogComponent,
  },
})
export default class ClientAdministrationPartners extends Vue {
  @Prop({ required: true }) clientId!: string;
  /** The client's Kürzel, for the sign-in address a new system is proposed. */
  @Prop({ default: null }) clientPrefix!: string | null;

  @Ref("createDialog") readonly createDialog!: ClientPartnerCreateDialogComponent;
  @Ref("passwordDialog") readonly passwordDialog!: ClientPartnerPasswordDialogComponent;

  partners: ClientPartnerSummary[] = [];
  mayCreate = false;
  isLoading = true;
  loadFailed = false;

  get mayEdit(): boolean {
    return adminPortalChangeAccess(getReactiveActiveUser());
  }

  /** Created, its password shown once, then its page opened (merge 3). */
  async onCreate() {
    const created = await this.createDialog.show(this.clientId, this.clientPrefix);
    if (!created) {
      return;
    }
    await this.passwordDialog.show(created.partner.name, created.partner.access?.email ?? null, created.password);
    router.push({ name: ComponentName.CLIENT_ADMINISTRATION_PARTNER, query: { clientId: this.clientId, partnerId: created.partner.id } });
  }

  systemLabelKey(system: string | null): string {
    return partnerSystemLabelKey(system);
  }

  /** A partner opens on its owner's page: for a member's read-only line, the master's. */
  open(partner: ClientPartnerSummary) {
    router.push({
      name: ComponentName.CLIENT_ADMINISTRATION_PARTNER,
      query: { clientId: partner.editable ? this.clientId : partner.ownerClientId, partnerId: partner.id },
    });
  }

  @Watch("clientId", { immediate: true })
  async load() {
    if (!this.clientId) {
      return;
    }
    this.isLoading = true;
    this.loadFailed = false;
    try {
      const list = await listClientPartners(this.clientId);
      this.partners = list.partners;
      this.mayCreate = list.mayCreate;
    } catch {
      // Shown in the card; the rest of the detail is unaffected.
      this.loadFailed = true;
    }
    this.isLoading = false;
  }
}
